export const addS = (count: number, word: string): string =>
  count === 1 ? word : `${word}s`;
